import { history } from "state/history";

export default function goToShopItemSaga(action) {
  history.push(`/school_money/shop/${action.payload.studentID}/`);
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/goToShopItemSaga.js